import Vue from 'vue';
import Router from 'vue-router';

import GetStartedView from './views/GetStartedView.vue';
import PaymentOnboarding from './views/payment/PaymentOnboarding.vue';
import OAuthCallbackView from './views/auth/OAuthCallbackView.vue';
import OAuthLogoutView from './views/auth/OAuthLogoutView.vue';
import PaymentFailure from './views/payment/PaymentFailure.vue';
import PaymentSuccess from './views/payment/PaymentSuccess.vue';
import ListDisputeView from './views/disputes/ListDisputeView.vue';
import ListRefundView from './views/refunds/ListRefundView.vue';
import ListCaptureView from './views/captures/ListCaptureView.vue';
import MainView from './views/MainView.vue';
import routeGuard from './routing/routingHelper';
import BankingOnboarding from './views/banking/BankingOnboarding.vue';
import AddUserView from './views/user/AddUserView.vue';
import EditUserView from './views/user/EditUserView.vue';
import ListUserView from './views/user/ListUserView.vue';
import ShowFleetView from './views/fleet/ShowFleetView.vue';
import FailedCapturesView from './views/failed/FailedCapturesView.vue';
import ListPayoutsView from './views/payouts/ListPayoutsView.vue';
import { RoutePath } from './routing/routePath';

import ListPrivacyPolicy from './views/privacyPolicy/ListPrivacyPolicyView.vue';
import ListTermAndCondition from './views/termAndCondition/ListTermAndConditionView.vue';
import AppPublishKeySettingView from './views/appPublishKeySettings/AppPublishKeySettingView.vue';


Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'welcome',
      component: GetStartedView,
    },
    {
      path: '/captures/',
      name: 'captures',
      component: ListCaptureView,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/refunds/',
      name: 'refunds',
      component: ListRefundView,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/disputes/',
      name: 'disputes',
      component: ListDisputeView,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: RoutePath.FAILED_CAPTURES,
      name: 'failed-transactions',
      component: FailedCapturesView,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/main',
      name: 'main',
      component: MainView,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/payment-onboarding',
      name: 'payment-onboarding',
      component: PaymentOnboarding,
      meta: { hasNavigation: true, showFleetSelector: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/banking-onboarding',
      name: 'banking-onboarding',
      component: BankingOnboarding,
      meta: { hasNavigation: true, showFleetSelector: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/payment/failure',
      name: 'payment-failure',
      component: PaymentFailure,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/payment/success',
      name: 'payment-success',
      component: PaymentSuccess,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/users/',
      name: 'users',
      component: ListUserView,
      meta: { hasNavigation: true, hasVersion: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/users/new',
      name: 'new-users',
      component: AddUserView,
      meta: { hasNavigation: true, hasVersion: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/users/edit',
      name: 'edit-user',
      props: true,
      component: EditUserView,
      meta: { hasNavigation: true, hasVersion: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/fleet/',
      name: 'fleet',
      component: ShowFleetView,
      meta: { hasNavigation: true, hasVersion: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/reporting/payouts',
      name: 'payouts',
      component: ListPayoutsView,
      meta: { hasNavigation: true, hasVersion: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/oauth/callback',
      name: 'oauth-callback',
      component: OAuthCallbackView,
    },
    {
      path: '/logout',
      name: 'logout',
      component: OAuthLogoutView,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: ListPrivacyPolicy,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: ListTermAndCondition,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
    {
      path: '/app-publish-key-settings',
      name: 'app-publish-key-settings',
      component: AppPublishKeySettingView,
      meta: { hasNavigation: true },
      beforeEnter: routeGuard,
    },
  ],
});
